import { Injectable } from "@angular/core";
import Claim from "../../../core/data/models/claim.model";
import { BaseCrudService } from "../../../core/data/services/base-crud.service";
import { PreClaimRequest } from "../../../core/data/dtos/preclaim.request";

@Injectable()
export class PreClaimService extends BaseCrudService<{}> {
    controller = 'PreClaim';

    createPreClaim(request: PreClaimRequest) {
        return this.create<PreClaimRequest, string>(request, 'create', undefined, false);
    }

    validateCode(code: string, claimReferenceNumber: string) {
        return this.get<void>({ code, claimReferenceNumber }, 'validate');    
    }
}